<!--
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-07-09 20:47:40
 * @FilePath: \mrc-base-frontend\src\components\mrc_ess_table.vue
-->
<template>
  <v-card class="tableBoxComponent" :class="dense ? 'denseHeight' : ''">
    <!--  v-if="!hideAddBtn" -->
    <mrc_ess_addBtn :hideAddBtn="hideAddBtn" :list="addBtnList" @handleAdd="handleAdd" :pageName="pageName">
      <slot name="btns"></slot>
    </mrc_ess_addBtn>
    <slot name="search" />
    <!-- :item-key="itemKey" -->
    <mrc_ess_skeleton_loader :loading="isLoading">
      <v-data-table :headers="showHeaders" :dense="dense" :value="selectedArr" @input="selectedInput" :page.sync="page"
        :loading-text="$t('label_loadingItem')" :loading="isLoading" @click:row="clickRow"
        :hide-default-header="hideDefaultHeader" disable-sort :locale="$store.state.lang" :search="search" fixed-header
        style="padding: 16px 16px 0 16px" hide-default-footer :show-select="showSelect" :single-expand="singleExpand"
        :show-expand="showExpand" :item-key="itemKey" :items="items"
        :items-per-page="hideFooter ? 10000 : options.pagesize" @page-count="pageCount">
        <template v-for="it in headerName" :slot="'header.' + it" slot-scope="{ item }">
          <slot :name="'header.' + it" :item="item" />
        </template>
        <!-- :height="tableHeight" -->
        <template v-for="it in slotKey" :slot="'item.' + it" slot-scope="{ item }">
          <slot :name="'item.' + it" :item="item" />
        </template>
        <!-- <template slot='top'> -->
        <slot name="top" slot="top" />
        <!-- </template> -->
        <!-- <template v-slot:top>
        <slot name="top" />
      </template> -->
        <template v-slot:no-data>
          <mrc_ess_noContent :no_data_text="$t('label_blank')" />
        </template>
        <!-- <template v-slot:header.data-table-select="{ on, props }">
          <slot name="header.data-table-select"
                :on="on"
                :props="props">
            <v-simple-checkbox color="primary"
                               v-bind="props"
                               v-on="on"></v-simple-checkbox>
          </slot>
        </template> -->
        <!-- <template v-slot:item.data-table-select="{ isSelected, select }">
          <slot name="item.data-table-select"
                :isSelected="isSelected"
                :select="select">
            <v-simple-checkbox color="primary"
                               :value="isSelected"
                               @input="select($event)"></v-simple-checkbox>
          </slot>
        </template> -->
        <slot slot="body" :items="items" :headers="headers">
          <slot name="body.prepend"> </slot>
          <tbody v-if="items.length <= 0 && (!appendItems)">
            <tr>
              <td :colspan="slotKey.length + (showSelect ? 2 : 1)">
                <mrc_ess_noContent :no_data_text="$t('label_blank')" />
              </td>
            </tr>
          </tbody>
          <draggable :list="items" @change="onMove" draggable=".dragcol" tag="tbody" item-key="uuid"
            v-bind="{ animation: 500 }" v-if="draggable">
            <tr v-for="item in items" :key="item.value" class="dragcol">
              <td class="px-0">
                <span class="d-flex flex-row flex-nowrap align-center">
                  <v-icon class="grey--text ml-n1" :style="{
                    cursor: 'grab', fontSize: '18px'
                  }"> drag_indicator </v-icon>
                  <v-simple-checkbox color="primary" class="ml-n1" :ripple="false" :key="item.value" v-if="showSelect"
                    :value="selectedArr.includes(item)" @input="() => {
                      if (selectedArr.includes(item)) {
                        selectedArr.splice(selectedArr.indexOf(item), 1)
                      } else {
                        selectedArr.push(item)
                      }
                    }"></v-simple-checkbox>
                </span>
              </td>
              <template v-for="it in slotKey">
                <td>
                  <slot :name="'item.' + it" :item="item" />
                </td>
              </template>
              <td>
                <slot name='item.actions' :item="item" />
              </td>
            </tr>
          </draggable>
        </slot>
        <slot name="header" slot="header" :header="headers"></slot>

        <template v-slot:body.prepend="{ item, headers }">
          <slot name="body.prepend" :item="item"> </slot>
        </template>

        <template v-slot:expanded-item="{ item, headers }">
          <slot name="expanded-item" :item="item" :headers="headers"> </slot>
        </template>

        <!-- <slot v-for="(it) in headers"
            :slot="'item.' + it.value"
            :name="'item.' + it.value"
            slot-scope="{item}"
            :item='item'></slot> -->

        <!-- <slot name='item.name'
            slot='item.name'
            slot-scope="{item}"
            :item='item'></slot> -->

        <template slot="item.actions" slot-scope="{ item }">
          <slot name="item.actions" :item="item"></slot>
        </template>

        <!-- ="{ headers }" -->
        <template v-slot:header.actions>
          <v-tooltip bottom v-if="draggableStatus">
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon @click="changedraggableList">
                <span class="material-icons">settings</span>
              </v-btn>
            </template>
            <span>
              {{ $t("label_customized_column") }}
            </span>
          </v-tooltip>
        </template>
        <template v-slot:footer v-if="!hideFooter">
          <mrc_ess_paginations v-model="options" @change="turnPage"></mrc_ess_paginations>
        </template>
      </v-data-table>

      <!-- tools -->
      <template>
        <v-dialog v-model="show" width="50vw" persistent scrollable>
          <v-card>
            <v-card-title style="
                background-color: #000000;
                color: #ffffff;
                padding: 2px 12px;
              ">
              <span class="text-body-s">
                {{ $t("label_customized_column") }}
              </span>
              <v-spacer></v-spacer>
              <v-btn icon style="cursor: pointer; font-size: 20px; color: #ffffff" @click.stop="show = false">
                <v-icon>clear</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text class="px-8">
              <div class="pl-1 text-body-s" style="color: rgba(0, 0, 0, 0.78)">
                {{ $t("label_row_height") }}
              </div>
              <div class="pl-1">
                <v-radio-group v-model="dense" row>
                  <v-radio :label="$t('label_general')" :value="false"></v-radio>
                  <v-radio :label="$t('label_narrow')" :value="true"></v-radio>
                </v-radio-group>
              </div>
              <div class="pl-1 text-body-s" style="color: rgba(0, 0, 0, 0.78)">
                {{ $t("label_dynamic_bar") }}
              </div>
              <!-- draggable=".drag"  :list="curHeaders" -->
              <draggable v-model="dragArr" draggable=".drag" v-bind="{ animation: 1000 }">
                <v-sheet class="d-flex flex-grow-1 pa-0 align-center" :class="canDrag(item.value) ? 'drag' : ''"
                  v-for="(item, index) in dragArr" :key="item.value">
                  <v-hover v-slot:default="{ hover }" open-delay="100" :style="{
                    cursor: canDrag(item.value) ? 'grab' : 'not-allowed',
                  }" :class="index == 0 ? '' : 'mt-2'">
                    <!-- :color="canDrag(item.value) ? 'white' : 'grey lighten-3'" -->
                    <v-card class="
                        white
                        d-flex
                        flex-row
                        justify-start
                        flex-grow-1
                        pa-0
                        align-center
                      " style="border-radius: 0px" height="48" :elevation="hover && canDrag(item.value) ? 8 : 0"
                      color="white">
                      <v-icon class="mr-6"> drag_indicator </v-icon>
                      <v-checkbox color="primary" class="mt-0 pt-0" @change="onSelect" :disabled="!canDrag(item.value)"
                        v-model="item.mrcSelected" :label="canDrag(item.value)
                          ? item.text
                          : $t('label_operating')
                          " hide-details></v-checkbox>
                    </v-card>
                  </v-hover>
                </v-sheet>
              </draggable>
            </v-card-text>
            <!-- :loading="loading" -->
            <!-- <mrc_ess_submitBtn @cancel="cancel"
                               style="height: auto;padding: 24px 0"
                               @success="success"></mrc_ess_submitBtn> -->
            <!-- <CardActions saveBtn @save="toSave" @cancel="show = false" /> -->
          </v-card>
        </v-dialog>
      </template>
    </mrc_ess_skeleton_loader>
  </v-card>
</template>

<script>
import draggable, { filter } from "vuedraggable";
export default {
  components: { draggable },
  props: {
    // dense: {
    //   default: false,
    //   type: Boolean
    // },
    headerName: {
      type: Array,
    },

    headers: { default: () => [], type: [Array] },
    appendItems: { default: undefined, type: [Object, Boolean] },
    itemKey: { default: "uuid", type: String },
    showSelect: { default: false, type: Boolean },
    items: { default: () => [], type: Array },
    showExpand: { type: Boolean, default: false },
    singleExpand: { type: Boolean, default: false },
    expanded: {},
    hideDefaultHeader: {
      type: Boolean,
      default: false,
    },
    paginationOptions: {
      type: Object,
    },
    hideAddBtn: {
      type: Boolean,
      default: false,
    },
    selectedArr: {
      type: Array,
    },
    addBtnList: {
      type: Array,
    },
    pageName: {
      type: String,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    slotKey: {
      type: Array,
      default: () => ["actions"],
    },
    hideFooter: {
      type: Boolean,
      default: false,
    },
    search: {
      type: String,
      default: "",
    },
    draggable: {
      type: [Boolean, Number],
      default: false,
    },
    draggableStatus: {
      //隐藏定制栏
      type: Boolean,
      default: true,
    },
  },
  model: {
    prop: "selectedArr",
    event: "change",
  },
  data() {
    return {
      dense: false,
      expandedchildren: [],
      page: 1,
      show: false,
      refresh: Math.random() * 10000000,
      selected: [],
      dragArr: [],
      cannotDrag: ["actions", "drag"],
      options: {
        pagesize: 20, //条数
        cpage: this.$store.state.cpage, //页数
        totalcount: 0, //总条数
        totalpage: 0, //总页数
        selectlist: [10, 20, 50, 100, 200],
        pagetext: this.$t("label_Each_page_shows"),
      },
      tableHeight: "",
      obj: {},
      // showHeaders: [],
      curHeaders: [],
    };
  },
  computed: {
    showHeaders() {
      return this.dragArr.filter((ele) => ele.mrcSelected === true);
    },
  },
  created() {
    this.headers.forEach((item) => {
      item["mrcSelected"] = true;
    });
    this.dragArr = this.headers;
  },
  watch: {
    // selected: {
    //   handler (v) {
    //     this.$emit('change', v)
    //   },
    //   deep: true,
    // },
    headers: {
      handler(v) {
        this.dragArr.forEach((item) => {
          v.forEach((item1) => {
            if (item1.value == item.value) {
              item.text = item1.text;
            }
          });
        });
      },
      deep: true,
    },
    expanded: {
      handler(val) { },
    },
    paginationOptions: {
      handler(val) {
        Object.assign(this.options, val);
      },
      deep: true,
    },
    search(v) { },
  },
  mounted() {
    Object.assign(this.options, this.paginationOptions);
    this.tableHeight = window.document.documentElement.clientWidth * 0.35;
    // this.lists = JSON.parse(JSON.stringify(this.items))
  },

  methods: {
    /**
     * @description: 
     * @param {*} evt.moved
     * @param {*} evt.moved.element
     * @param {*} evt.moved.oldIndex{}
     * @param {*} evt.moved.newIndex{}
     * @return {*}
     */
    onMove(evt) {
      let index = evt.moved.newIndex + 1;
      if (this.items[index]) {
        this.$emit('move', evt.moved.element, this.items[index]['sequence'])
      } else if (this.items[index - 2]) {
        this.$emit('move', evt.moved.element, this.items[index - 2]['sequence'])
      }
    },
    selectedInput(val) {
      // console.log(val);
      this.$emit("change", val);
    },
    updateExpanded(val) { },
    itemExpanded(val) { },
    canDrag(value) {
      if (this.cannotDrag.indexOf(value) != -1) {
        return false;
      } else {
        return true;
      }
    },
    onSelect: function (val) {
      this.refresh = Math.random() * 10000000;
    },
    pageCount(num) {
      // console.log(num, 'pageCount')
    },
    turnPage(options) {
      this.$store.commit("setCpage", options.cpage);
      this.$store.commit("setPagesize", options.pagesize);
      this.$emit("turnPage", options);
    },
    handleAdd() {
      this.$emit("handleAdd");
    },
    clickRow(val) {
      this.$emit("click:row", val);
    },
    changedraggableList() {
      this.show = true;
      // this.dragArr = this.$clone(this.headers)
    },
    cancel() {
      // this.zcArr
      //   ? (this.dragArr = this.$clone(this.zcArr))
      //   : (this.dragArr = this.headers)
      // this.show = false
      // this.dragArr = this.$clone(this.showHeaders)
    },
    success() {
      // this.zcArr = this.$clone(this.dragArr)
      // this.curHeaders = this.$clone(this.dragArr).filter((item) => {
      //   return item.mrcSelected === true
      // })
      // this.show = false
    },
  },
};
</script>

<style scoped>
.tableBoxComponent /deep/ .v-data-table-header th {
  font-family: var(--body-font-family);
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.38);
}

.tableBoxComponent /deep/ .v-data-table {
  /* border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px; */
  border-radius: 8px;
}

.tableBoxComponent /deep/ .v-data-table__wrapper {
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
}

.tableBoxComponent /deep/ .v-data-table__wrapper td {
  font-family: var(--body-font-family);
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #383838;
}

.tableBoxComponent /deep/ .theme--light.v-data-table thead tr th {
  color: rgba(0, 0, 0, 0.38);
}

/deep/ .v-input .v-label {
  font-family: var(--body-font-family);
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 125%;
  color: rgba(0, 0, 0, 0.87);
}

.tableBoxComponent /deep/ .v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
  padding: 8px 16px;
}

.denseHeight /deep/ .v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
  padding: 4px 16px;
}

/* .v-data-table .v-data-table__wrapper td {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
} */
.tableBoxComponent /deep/ .v-simple-checkbox .v-icon {
  color: #0f46c1 !important;
}
</style>
